import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/section

export const Section = styled.section`
  display: flex;
`;
